/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Active_OrdersInputs */

const en_metric_active_orders = /** @type {(inputs: Metric_Active_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Orders`)
};

const es_metric_active_orders = /** @type {(inputs: Metric_Active_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos activos`)
};

/**
* | output |
* | --- |
* | "Active Orders" |
*
* @param {Metric_Active_OrdersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const metric_active_orders = /** @type {((inputs?: Metric_Active_OrdersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Active_OrdersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_metric_active_orders(inputs)
	return es_metric_active_orders(inputs)
});